import { useState } from "react";
import { Eyebrow } from "@/components/bits";
import { useLang } from "@/i18n";

// ═══ Editable seed data — founders edit these two arrays only ═══
// Zone: { locality, zone, segment, rate (display), rateNum (heat), yoy, appr, note, col, row }
// Grid is 1-indexed: col 1 = far west → col 6 = far east; row 1 = north → row 6 = south.
export const ZONES = [
  { locality: "Patia", zone: "North", segment: "Premium (IT corridor)", rate: "₹7,950", rateNum: 7950, yoy: "+15.2%", appr: "+37.3%", note: "Top investor pick near KIIT/Infocity; some cooling this year", col: 4, row: 1 },
  { locality: "Chandrasekharpur", zone: "North", segment: "Mid-Premium (IT corridor)", rate: "₹9,300", rateNum: 9300, yoy: "+17.7%", appr: "—", note: "Family belt near KIIT/Infocity; BDA new housing announced", col: 3, row: 1 },
  { locality: "Pahala", zone: "North peri-urban", segment: "Plotting / Emerging", rate: "Plots vary", rateNum: 0, yoy: "High", appr: "+140.0%", note: "Top 3-yr appreciation pocket in city", col: 5, row: 1 },
  { locality: "Phulnakhara", zone: "East", segment: "Mid", rate: "Mid", rateNum: 0, yoy: "—", appr: "—", note: "Emerging east pocket", col: 6, row: 1 },
  { locality: "Jaydev Vihar", zone: "Central", segment: "Premium", rate: "₹8,000–10,250", rateNum: 8000, yoy: "—", appr: "—", note: "Central premium; Penguin Tower", col: 4, row: 2 },
  { locality: "Hanspal", zone: "East", segment: "Affordable", rate: "₹5,900", rateNum: 5900, yoy: "+12.9%", appr: "High", note: "Best rental-yield belt; Assotech Avenue 7", col: 6, row: 2 },
  { locality: "Raghunathpur", zone: "North peri-urban", segment: "Plotting", rate: "₹1,950–3,000", rateNum: 1950, yoy: "—", appr: "—", note: "Plotted/villa, smart-city plots", col: 1, row: 2 },
  { locality: "Nayapalli / IRC Village", zone: "Central", segment: "Premium (mature)", rate: "₹10,250", rateNum: 10250, yoy: "+9.6%", appr: "Low-risk", note: "Highest established locality rate; boutique towers", col: 3, row: 3 },
  { locality: "Saheed Nagar", zone: "Central", segment: "Premium", rate: "₹8,500–11,000", rateNum: 8500, yoy: "~5–6%", appr: "Low-risk", note: "DN Homes premium line; commercial hub emerging", col: 4, row: 3 },
  { locality: "Laxmisagar", zone: "Central-East", segment: "Mid", rate: "₹7,500", rateNum: 7500, yoy: "0.0%", appr: "—", note: "Established residential", col: 5, row: 3 },
  { locality: "Cuttack-Puri Road", zone: "East", segment: "Mid-Premium", rate: "₹7,400", rateNum: 7400, yoy: "+11.3%", appr: "—", note: "Arterial corridor", col: 6, row: 3 },
  { locality: "Khandagiri / Chandaka Rd", zone: "West", segment: "Value-Mid", rate: "₹5,500–6,500", rateNum: 5500, yoy: "~7%", appr: "—", note: "DN OxyPark, Vaishno Greens, DN New Town", col: 2, row: 3 },
  { locality: "Sijua", zone: "West peri-urban", segment: "Plotting / Emerging", rate: "Plots vary", rateNum: 0, yoy: "High", appr: "+100.0%", note: "High-appreciation plotted belt", col: 1, row: 3 },
  { locality: "Tankapani Road", zone: "East / Old Town", segment: "Premium-tagged", rate: "₹7,900", rateNum: 7900, yoy: "~7–8%", appr: "—", note: "End-user oriented, Old Town side", col: 5, row: 4 },
  { locality: "Rasulgarh", zone: "East", segment: "Mid-Premium", rate: "₹6,800", rateNum: 6800, yoy: "+5.4%", appr: "—", note: "Commercial + residential hub", col: 6, row: 4 },
  { locality: "Ghatikia", zone: "West (near AIIMS)", segment: "Value-Mid", rate: "₹4,500–6,000", rateNum: 4500, yoy: "~3% yield", appr: "Steady", note: "Trinity Chanakya, 31 Forest Park", col: 2, row: 4 },
  { locality: "Baramunda", zone: "Central", segment: "Affordable", rate: "Affordable", rateNum: 0, yoy: "—", appr: "—", note: "Affordable housing belt", col: 3, row: 4 },
  { locality: "Tamando", zone: "South-West", segment: "Emerging growth", rate: "₹6,500", rateNum: 6500, yoy: "+12.1%", appr: "High", note: "Fast-growing peripheral corridor", col: 2, row: 5 },
  { locality: "Bijipur", zone: "South", segment: "Mid", rate: "₹6,500", rateNum: 6500, yoy: "+12.1%", appr: "—", note: "Emerging", col: 3, row: 5 },
  { locality: "Sundarpada", zone: "South", segment: "Mid / Affordable", rate: "₹5,300", rateNum: 5300, yoy: "+14.0%", appr: "High", note: "First-time buyer belt; 20–25 min from centre", col: 4, row: 5 },
  { locality: "Patrapada", zone: "South-West", segment: "Emerging growth", rate: "₹4,000–5,500", rateNum: 4000, yoy: "High", appr: "+126.7%", note: "One of the fastest-appreciating pockets", col: 1, row: 5 },
  { locality: "Janla", zone: "South", segment: "Affordable villas", rate: "₹2,100–2,150", rateNum: 2100, yoy: "—", appr: "—", note: "KN Ananta Villa, Sai Krishna Residency", col: 2, row: 6 },
  { locality: "Madanpur / Kantabada", zone: "West periphery", segment: "Value / Entry", rate: "₹1,700–2,800", rateNum: 1700, yoy: "—", appr: "—", note: "Lowest entry rates; Bivab Angan, TSL Spring City", col: 1, row: 6 },
];

// Project: { locality, project, developer, config, status, rate, units }
export const PROJECTS = [
  { locality: "Patia", project: "DN Vipul Garden", developer: "DN Homes", config: "2/3/4 BHK", status: "Ongoing", rate: "6,500–8,500", units: "from 1,362 sqft" },
  { locality: "Patia", project: "Mason Luxuria", developer: "Mason Estate India", config: "2/3 BHK", status: "Under Construction", rate: "6,500–8,000", units: "low-rise" },
  { locality: "Patia", project: "High Field Smart Nest", developer: "High Field", config: "2/3 BHK", status: "New Launch", rate: "6,000–7,500", units: "—" },
  { locality: "Patia", project: "Chitraka Meadows", developer: "—", config: "2/3 BHK", status: "New Launch", rate: "6,000–7,500", units: "—" },
  { locality: "Patia", project: "Somu Residency Phase 1", developer: "Reputed Developer", config: "2/3 BHK", status: "Ready to Move", rate: "6,000–7,500", units: "1,098–1,809 sqft" },
  { locality: "Patia", project: "Shuvam Daitari Enclave", developer: "Local builder", config: "2/3 BHK", status: "Advanced Stage", rate: "region avg", units: "128 units" },
  { locality: "Patia", project: "Essen Raj Manoher Residency", developer: "Local builder", config: "2/3 BHK", status: "Mid Stage", rate: "region avg", units: "140 units" },
  { locality: "Chandrasekharpur", project: "BDA New Housing Scheme", developer: "Bhubaneswar Dev. Authority", config: "—", status: "Announced", rate: "~9,300", units: "Chandrasekharpur/Jagasara/Sanapalla" },
  { locality: "Chandrasekharpur", project: "Multiple UC launches", developer: "Various", config: "2/3 BHK", status: "Under Construction", rate: "5,500–9,300", units: "—" },
  { locality: "Khandagiri", project: "DN OxyPark", developer: "DN Homes", config: "2/3 BHK", status: "Ready to Move", rate: "region 4,200–6,500", units: "84 units" },
  { locality: "Khandagiri", project: "DN New Town (plots)", developer: "DN Homes", config: "Plots", status: "Ready", rate: "on request", units: "1,395–5,580 sqft" },
  { locality: "Khandagiri", project: "Vaishno Greens", developer: "—", config: "2/3 BHK", status: "Ongoing", rate: "~5,000", units: "132 units / 6 bldgs" },
  { locality: "Khandagiri", project: "Fortune Om Shivalik", developer: "—", config: "2.5/3.5 BHK", status: "Ongoing", rate: "5,000+", units: "1,990–2,516 sqft" },
  { locality: "Khandagiri", project: "Urbanyx Court", developer: "—", config: "Luxury apts", status: "Ongoing", rate: "Premium", units: "—" },
  { locality: "Ghatikia", project: "Trinity Chanakya", developer: "—", config: "2/3 BHK", status: "New / Ongoing", rate: "4,500–6,000", units: "—" },
  { locality: "Ghatikia", project: "31 Forest Park", developer: "Harshpriya Constructions", config: "Low-density", status: "New Launch", rate: "Premium", units: "—" },
  { locality: "Patrapada", project: "Maa Santoshi Enclave", developer: "Maa Santoshi Engineers", config: "—", status: "New Launch", rate: "4,000–5,500", units: "—" },
  { locality: "Patrapada", project: "Blueprint Signature", developer: "Blueprint Constructions", config: "—", status: "Under Construction", rate: "4,000–5,500", units: "—" },
  { locality: "Sundarpada", project: "Bivab Heritage", developer: "Bivab Developers", config: "2/3 BHK", status: "Ongoing", rate: "3,500–5,500", units: "—" },
  { locality: "Sundarpada", project: "Motwani Vinayak Enclave", developer: "Motwani Construction", config: "2/3/4 BHK", status: "Ongoing", rate: "3,500–5,500", units: "—" },
  { locality: "Sundarpada", project: "Metro Mansion", developer: "—", config: "2/3 BHK", status: "Ongoing", rate: "3,500–5,500", units: "—" },
  { locality: "Hanspal", project: "Assotech Avenue 7", developer: "Assotech Builders", config: "Luxury", status: "Under Construction", rate: "~5,900", units: "—" },
  { locality: "Hanspal", project: "HK City 2", developer: "—", config: "Plots/Apts", status: "Ongoing", rate: "4,000–6,000", units: "—" },
  { locality: "Madanpur", project: "Bivab Angan", developer: "Bivab Developers", config: "2/3 BHK", status: "Advanced Stage", rate: "2,750", units: "650 units" },
  { locality: "Madanpur", project: "Jayaguru IT City Phase 1", developer: "—", config: "Plots", status: "Ongoing", rate: "Entry", units: "—" },
  { locality: "Kantabada", project: "TSL Spring City", developer: "TSL", config: "—", status: "Advanced Stage", rate: "1,696", units: "52 units" },
  { locality: "Janla", project: "KN Ananta Villa", developer: "KN Multiprojects", config: "Villa", status: "Ready to Move", rate: "2,100", units: "24 units" },
  { locality: "Janla", project: "Sai Krishna Residency", developer: "Sai Krishna Homes", config: "—", status: "Mid Stage", rate: "2,150", units: "112 units" },
  { locality: "Raghunathpur", project: "Regnant Raghunath Vihar", developer: "Regnant", config: "Plots", status: "Ongoing", rate: "1,950–3,000", units: "—" },
  { locality: "Raghunathpur", project: "New Smart City Residential Plots", developer: "—", config: "Plots", status: "Ongoing", rate: "1,950–3,000", units: "—" },
  { locality: "Pahala", project: "Pahala Plotting Project", developer: "—", config: "Plots", status: "Ongoing", rate: "appreciating", units: "140% 3-yr belt" },
  { locality: "Jaydev Vihar", project: "Penguin Tower", developer: "—", config: "Apartments", status: "Ongoing", rate: "8,000–10,250", units: "RCC frame, central premium" },
  { locality: "Phulnakhara", project: "Gulmohar Courts", developer: "—", config: "Apartments", status: "Ongoing", rate: "Mid", units: "16 units" },
  { locality: "Baramunda", project: "Z Baramunda Affordable Housing", developer: "Z Estates", config: "Affordable", status: "Ongoing", rate: "Affordable", units: "—" },
];

const heatOf = (n) => (n < 3000 ? 1 : n < 5000 ? 2 : n < 7000 ? 3 : n < 9000 ? 4 : 5);

const segClass = (s) => {
  const l = s.toLowerCase();
  if (l.includes("premium")) return "premium";
  if (l.includes("emerging")) return "emerging";
  if (l.includes("plotting")) return "plotting";
  return "mid";
};

const projectsFor = (zone) => {
  const zl = zone.locality.toLowerCase();
  const first = zl.split("/")[0].trim();
  return PROJECTS.filter((p) => {
    const pt = p.locality.toLowerCase();
    return zl.includes(pt) || pt.includes(first);
  });
};

const FILTERS = ["all", "premium", "mid", "emerging", "plotting"];
const HEAT_LABELS = ["<3k", "3–5k", "5–7k", "7–9k", "9k+"];

const clean = (v) => v && v !== "-" && v !== "—";

const Metric = ({ value, label }) =>
  clean(value) ? (
    <div>
      <p className="font-display text-2xl text-[var(--bone)] tracking-tight">{value}</p>
      <p className="font-mono-label text-[9px] tracking-[0.18em] uppercase text-[var(--bone-dim)] mt-1">
        {label}
      </p>
    </div>
  ) : null;

export const RisingMap = ({ onPickLocality }) => {
  const { t, tf } = useLang();
  const [filter, setFilter] = useState("all");
  const [selected, setSelected] = useState(null);

  const zones = ZONES.filter((z) => filter === "all" || segClass(z.segment) === filter);
  const zone = selected ? ZONES.find((z) => z.locality === selected) : null;
  const projects = zone ? projectsFor(zone) : [];

  return (
    <section data-testid="rising-map" className="rising py-24 md:py-32 border-t border-[#1A2A24]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-[760px]">
          <Eyebrow>{t("rm.eyebrow")}</Eyebrow>
          <h2
            className="font-display tracking-tight text-[var(--bone)] leading-[1.04] mt-5"
            style={{ fontSize: "clamp(34px, 5vw, 60px)" }}
          >
            {t("rm.h2a")}{" "}
            <em className="italic text-[var(--brass)]">{t("rm.h2em")}</em>
          </h2>
          <p className="font-light text-base md:text-lg text-[var(--bone-dim)] leading-relaxed mt-6 max-w-[620px]">
            {t("rm.sub")}
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2.5 mt-12">
          <span className="font-mono-label text-[10px] tracking-[0.25em] uppercase text-[var(--bone-dim)] mr-2">
            {t("rm.filter")}
          </span>
          {FILTERS.map((f) => (
            <button
              key={f}
              type="button"
              data-testid={`rm-filter-${f}`}
              onClick={() => setFilter(f)}
              className={`rm-chip ${filter === f ? "active" : ""}`}
            >
              {t(`rm.f.${f}`)}
            </button>
          ))}
        </div>

        <div className="rm-wrap mt-10">
          <div className="rm-map" data-testid="rm-map">
            <span className="rm-compass rm-n">North</span>
            <span className="rm-compass rm-s">South</span>
            <span className="rm-compass rm-e">East</span>
            <span className="rm-compass rm-w">West</span>
            <div className={`rm-stage ${zone ? "dimmed" : ""}`}>
              {zones.map((z) => (
                <button
                  key={z.locality}
                  type="button"
                  data-testid={`rm-zone-${z.locality.split(" ")[0].toLowerCase()}`}
                  data-heat={heatOf(z.rateNum)}
                  className={`rm-zone ${selected === z.locality ? "active" : ""}`}
                  style={{ gridColumn: z.col, gridRow: z.row }}
                  onMouseEnter={() => setSelected(z.locality)}
                  onFocus={() => setSelected(z.locality)}
                  onClick={() => setSelected(z.locality)}
                >
                  <span className="rm-zname">{z.locality}</span>
                  <span className="rm-zrate">{z.rate}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="rm-panel" data-testid="rm-panel" aria-live="polite">
            {!zone ? (
              <div className="m-auto text-center px-8 py-16">
                <p className="font-display italic text-2xl text-[var(--bone)] tracking-tight">
                  {t("rm.empty.h")}
                </p>
                <p className="font-light text-sm text-[var(--bone-dim)] leading-relaxed mt-4 max-w-[280px] mx-auto">
                  {t("rm.empty.sub")}
                </p>
              </div>
            ) : (
              <>
                <div className="p-6 pb-5">
                  <h3 className="font-display text-[30px] text-[var(--bone)] tracking-tight leading-tight">
                    {zone.locality}
                  </h3>
                  <p className="font-mono-label text-[10px] tracking-[0.16em] uppercase text-[var(--brass)] mt-2">
                    {zone.zone} · {zone.segment}
                  </p>
                </div>
                <div className="flex flex-wrap gap-[18px] px-6 py-4 border-y border-[var(--line)]">
                  <Metric value={zone.rate} label={t("rm.m.rate")} />
                  <Metric value={zone.yoy} label={t("rm.m.yoy")} />
                  <Metric value={zone.appr} label={t("rm.m.appr")} />
                </div>
                <p className="font-light text-[13px] text-[var(--bone-dim)] leading-relaxed px-6 pt-4">
                  {zone.note}
                </p>
                <p className="font-mono-label text-[10px] tracking-[0.2em] uppercase text-[var(--bone-dim)] px-6 pt-5">
                  {tf("rm.projects", { N: projects.length })}
                </p>
                <div className="flex-1 overflow-y-auto px-6 mt-2 max-h-[260px]">
                  {projects.length === 0 ? (
                    <p className="font-light text-[13px] text-[var(--bone-dim)] py-4">
                      {t("rm.noProjects")}
                    </p>
                  ) : (
                    projects.map((p) => (
                      <div key={p.project} className="py-3.5 border-t border-[var(--line)] first:border-t-0">
                        <div className="flex items-baseline justify-between gap-3">
                          <p className="text-sm text-[var(--bone)]">{p.project}</p>
                          {clean(p.rate) && (
                            <p className="font-mono-label text-[10px] tracking-[0.1em] text-[var(--brass)] shrink-0">
                              {p.rate}
                            </p>
                          )}
                        </div>
                        <p className="flex flex-wrap items-center gap-x-2 gap-y-1.5 mt-2 font-mono-label text-[10.5px] tracking-[0.08em] uppercase text-[var(--bone-dim)]">
                          <span className="border border-[var(--line-brass)] text-[var(--brass)] px-1.5 py-0.5 rounded-[2px] text-[9px] tracking-[0.12em]">
                            {p.status}
                          </span>
                          {[p.developer, p.config, p.units].filter(clean).join(" · ")}
                        </p>
                      </div>
                    ))
                  )}
                </div>
                <div className="mt-auto border-t border-[var(--line)] bg-[var(--panel)] p-4 rounded-b-[4px]">
                  <button
                    type="button"
                    data-testid="rm-panel-cta"
                    onClick={() => onPickLocality(zone.locality)}
                    className="w-full font-mono-label text-[11px] tracking-[0.2em] uppercase bg-[var(--brass)] text-[var(--base)] px-6 py-3.5 rounded-[2px] hover:bg-[var(--bone)] transition-colors duration-300"
                  >
                    {tf("rm.panelCta", { locality: zone.locality })}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2.5 mt-8">
          <span className="font-mono-label text-[10px] tracking-[0.25em] uppercase text-[var(--bone-dim)] mr-2">
            {t("rm.legend")}
          </span>
          {[1, 2, 3, 4, 5].map((h) => (
            <span key={h} className="flex items-center gap-2">
              <span
                className="inline-block w-4 h-4 rounded-[2px] border border-[var(--line)]"
                data-heat={h}
                style={{
                  background:
                    h === 1
                      ? "rgba(94,133,112,.10)"
                      : h === 2
                      ? "rgba(184,137,75,.14)"
                      : h === 3
                      ? "rgba(184,137,75,.28)"
                      : h === 4
                      ? "rgba(184,137,75,.46)"
                      : "rgba(184,137,75,.70)",
                }}
              />
              <span className="font-mono-label text-[9px] tracking-[0.15em] uppercase text-[var(--bone-dim)]">
                {HEAT_LABELS[h - 1]}
              </span>
            </span>
          ))}
        </div>

        <p className="font-mono-label text-[10.5px] tracking-[0.08em] text-[var(--bone-dim)] leading-relaxed mt-8 max-w-[820px] opacity-80">
          {t("rm.caption")}
        </p>

        <div
          data-testid="rm-cta-bar"
          className="mt-12 border border-[var(--line-brass)] rounded-[4px] bg-gradient-to-r from-[var(--panel)] to-transparent p-7 md:p-9 flex flex-wrap items-center justify-between gap-6"
        >
          <p
            className="font-display tracking-tight text-[var(--bone)] leading-[1.15]"
            style={{ fontSize: "clamp(22px, 3vw, 32px)" }}
          >
            {t("rm.cta.a")}{" "}
            <em className="italic text-[var(--brass)]">{t("rm.cta.em")}</em>
          </p>
          <button
            type="button"
            data-testid="rm-bottom-cta"
            onClick={() => onPickLocality(null)}
            className="font-mono-label text-[11px] tracking-[0.2em] uppercase bg-[var(--brass)] text-[var(--base)] px-7 py-3.5 rounded-[2px] hover:bg-[var(--bone)] transition-colors duration-300"
          >
            {t("rm.cta.btn")}
          </button>
        </div>
      </div>
    </section>
  );
};
